<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="基本信息" name="1">
      <info-item
        :title="['客户名称', '商机名称']"
        :data="[detail.customerName, detail.name]"
      ></info-item>
      <info-item
        :title="['产品线', '客户意向']"
        :data="[detail.businessLineName, detail.intention]"
      ></info-item>
      <info-item
        :title="['预计成交金额(元)', '预计成交日期']"
        :data="[formatMoney(detail.dealAmountStr), detail.dealDate]"
      ></info-item>
      <info-item :title="['备注']" :data="[detail.remarks]"></info-item>
      <info-item
        :title="['业务员', '业务员所属部门']"
        :data="[detail.userName, detail.teamName]"
      ></info-item>
    </el-collapse-item>
    <el-collapse-item title="系统信息" name="2">
      <info-item
        :title="['创建人', '创建时间']"
        :data="[detail.creatorName, detail.gmtCreatedStr]"
      ></info-item>
      <info-item
        :title="['最后修改人', '最后修改时间']"
        :data="[detail.modifiedName, detail.gmtModifiedStr]"
      ></info-item>
      <info-item
        :title="['最新阶段变更时间', '最后跟进时间']"
        :data="[detail.stageChangeDate, detail.visitDateStr]"
      ></info-item>
      <info-item
        :title="['保护期倒计时']"
        :data="[`${detail.protectionPeriod}/90`]"
      ></info-item>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import InfoItem from "@/components/base/detail-info-item.vue";
import { formatMoney } from "@/scripts/utils";

export default {
  props: {
    detail: Object,
    contractModule: Number,
  },
  components: {
    InfoItem,
  },
  data() {
    return {
      activeNames: ["1", "2"],
    };
  },
  methods: {
    formatMoney,
  },
};
</script>

<style lang="less">
@import "~@/styles/common.less";

.panel-item {
  padding: 0 10px;
  label {
    width: 150px;
    display: inline-block;
    color: @color--info;
  }
  &:last-child {
    .el-col {
      border: none;
    }
  }
}
</style>
